import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
import { costs, faqs } from '../data/copy';
import { purchases } from '../data/testimonials';
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-21" data-mp="3pmbrfc9mo6zq">
        <div className="mx-auto max-w-3xl text-center" data-id="element-22" data-mp="3brj8e3uj48oe">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-light" aria-hidden="true" data-id="element-23" data-mp="3gkcccpi6bczf" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-24" data-mp="31v6g9aemu2vr">
            GARANTÍA 14 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-brand-green/40 p-7 sm:p-10" data-id="element-25" data-mp="36ussbgiq5d2z">
            <p className="text-slate-300" data-id="element-26" data-mp="2svaygmqkn9mr">
              Capturás. Organizás. Gestionás lo que llega con una rutina simple.
            </p>
            <p className="mt-4 text-slate-300" data-id="element-27" data-mp="2wxxtsxmgbcop">
              Si en 14 días sentís que no lográs ordenar la información que recibís, te devolvemos el
              100%.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-light sm:text-4xl" data-id="element-28" data-mp="2asgv7tiuwneg">
              Devolución del 100%
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-29" data-mp="2kr65b04ih3k5">sin formularios, sin drama.</p>
          </div>
          <p className="mt-5 text-sm text-slate-400" data-id="element-30" data-mp="1x12btll1ek6v">Tasa de devoluciones: menos del 1%.</p>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-31" data-mp="1s30im7twd4ho">
        <div className="mx-auto max-w-3xl" data-id="element-32" data-mp="1s0edsfye5335">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-33" data-mp="26s6p8gv2dwzl">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-34" data-mp="21z3va7mdkliv">
            {faqs.map((faq, index) => {
            const panelId = `faq-panel-${index}`;
            const isOpen = open === index;
            return <div key={faq.question} className="overflow-hidden rounded-xl border border-white/10 bg-brand-dark" data-id="element-35" data-mp="199n41dahrao8" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold sm:text-lg" data-id="element-36" data-mp="2305nqurqagwo">
                    <span data-id="element-37" data-mp="1k2mg9vkx56cd">{faq.question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-light transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-38" data-mp="1k3dzs818rdma" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-39" data-mp="30gmbwucqe9tt">
                    {isOpen && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.2,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-40" data-mp="35ee1hhpwljuu">
                        <p className="border-t border-white/10 px-5 py-5 leading-relaxed text-slate-300" data-id="element-41" data-mp="f490s1lijudd">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-42" data-mp="3sb0zxmob2g0u">
      <div className="mx-auto max-w-4xl" data-id="element-43" data-mp="3sclvnfmcw50a">
        <h2 className="text-center font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-44" data-mp="1vi7gyy0xljx5">
          ⚖️ ¿CUÁNTO CUESTA NO TENER EL SISTEMA?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-[#1a4a2e]" data-id="element-45" data-mp="1qh1lwtjstkkg">
          {costs.map(item => <p key={item} className="border-b border-l-4 border-[#1a4a2e] border-l-[#2d6b45] bg-[#0d2f1e] px-5 py-4 font-medium last:border-b-0" data-id="element-46" data-mp="23idmbzqwc3j8">
              <span className="mr-2 text-red-400" aria-hidden="true" data-id="element-47" data-mp="1tkh8v1ahkwhy">
                ×
              </span>
              {item}
            </p>)}
        </div>
        <p className="mt-12 text-center text-xl font-bold" data-id="element-48" data-mp="1frrk4p3kpdh5">El próximo lunes puede ser diferente.</p>
        <p className="mx-auto mt-5 max-w-3xl text-center font-display text-xl font-bold italic text-brand-light sm:text-2xl" data-id="element-49" data-mp="1kl424gdqym0x">
          “Tu información no es caos. Es una pila sin orden. Con un sistema simple, podés volver a
          tenerla bajo control.” 🧠
        </p>
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => window.clearInterval(timer);
  }, []);
  return <>
      <footer className="border-t border-white/10 bg-brand-ink px-4 py-12 text-center" data-id="element-50" data-mp="m93az86kcs3i">
        <span className="inline-block rounded-full border border-brand-green/25 bg-brand-green/10 px-3 py-1 text-sm font-semibold text-brand-light" data-id="element-51" data-mp="mbfwfvbj5klb">
          🎯 SISTEMA INFORMACIÓN BAJO CONTROL™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-slate-300" data-id="element-52" data-mp="19yfqsqwebyes">
          El protocolo de gestión de información para madres argentinas que acompañan a hijos con
          epilepsia refractaria.
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm italic text-slate-500" data-id="element-53" data-mp="1jwbwh36ke15i">
          Tu información no es caos. Es una pila sin orden.
        </p>

        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-54" data-mp="1ezlhkj6hxblo">
          <a className="transition-colors duration-150 ease-out hover:text-brand-light" href="mailto:soportebiomalivido@gmail.com" data-id="element-55" data-mp="ci9m7bfvqfpv">
            📧 soportebiomalivido@gmail.com
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-light" href="https://www.instagram.com/biomalivido/" target="_blank" rel="noreferrer" data-id="element-56" data-mp="qbr5qw8kfsfw">
            📲 @biomalivido
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-light" href="https://www.biomalivido.com" target="_blank" rel="noreferrer" data-id="element-57" data-mp="108407wbxqabp">
            🌐 biomalivido.com
          </a>
        </div>
        <p className="mt-8 text-xs text-slate-600" data-id="element-58" data-mp="3646wpy1j3amv">
          © SISTEMA INFORMACIÓN BAJO CONTROL™ 2026 — Todos los derechos reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-59" data-mp="33i7blh4odhk2">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-5 left-5 z-50 max-w-[285px] rounded-xl border border-brand-green/30 bg-brand-ink p-4 shadow-2xl" aria-live="polite" data-id="element-60" data-mp="33k1uyr0at1m1">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-light" data-id="element-61" data-mp="3mgte90fubgq3">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-62" data-mp="3hg5ki7088ls6" />
              Acceso confirmado
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-63" data-mp="38hk68o1sfsx7">
              {purchases[purchase][0]} de {purchases[purchase][1]}
            </p>
            <p className="text-sm text-slate-300" data-id="element-64" data-mp="2151lmt8j00xl">adquirió Sistema Información Bajo Control™</p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-65" data-mp="1x1c1cfyvw5id">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}